/* Publish by EComposer at 2026-10-24 18:55:56*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-b4tl94765mu"]=  window.__ectimmers["ecom-b4tl94765mu"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-b4tl94765mu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4tl94765mu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ot7qwuz2la').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ot7qwuz2la', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qo44zpw9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qo44zpw9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wv3jdb372').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wv3jdb372', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ytlmwqtod8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ytlmwqtod8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbufdl64at').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbufdl64at', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-67270tfoc5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-67270tfoc5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vpwo9oi9kdk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vpwo9oi9kdk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lqc4ckqrg6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lqc4ckqrg6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-547y9562oat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-547y9562oat', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9moznie92r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9moznie92r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-es2twg7oyhu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-es2twg7oyhu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hbj2y47imz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hbj2y47imz', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-amgvwta4v3d"]=  window.__ectimmers["ecom-amgvwta4v3d"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-amgvwta4v3d"]["zp6pcopcd"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-amgvwta4v3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amgvwta4v3d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-azqa77rdblj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azqa77rdblj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oiqnw453q0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oiqnw453q0n', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xsab8h7xu9b"]=  window.__ectimmers["ecom-xsab8h7xu9b"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-xsab8h7xu9b"]["b60lhoob3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-xsab8h7xu9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xsab8h7xu9b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddbdnbqu1le').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddbdnbqu1le', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5gv9ub3v96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5gv9ub3v96', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-66famkvdk2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-66famkvdk2m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmbwsub44vo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmbwsub44vo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aviorj42nck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aviorj42nck', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrxps5p26z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrxps5p26z', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sk014lix8gr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sk014lix8gr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9nd02w5gg0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nd02w5gg0t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1rkzxftsrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1rkzxftsrf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hh0vuvo6bl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hh0vuvo6bl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6itq24itkfi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6itq24itkfi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjz3kb9exa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjz3kb9exa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gr0vm0epcvj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gr0vm0epcvj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edd9bjevo46').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edd9bjevo46', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5eo0vxsjqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5eo0vxsjqg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}